<template>
  <div>
    <v-data-table
      :fixed-header="fixed_header"
      :fixed_footer="fixed_footer"
      :headers="headers"
      :items="items"
      :loading="loading"
      :loading-text="loading_text"
      :density="density"
      :items-per-page="items_per_page"
      :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
      :search="busqueda"
      :mobile-breakpoint="0"
      :dense="dense"
      :height="height"
      :show-select="show_select"
      :item-key="item_key"
      :disable-pagination="disable_pagination"
      :hide-default-footer="hide_default_footer"
      :locale="locale"
      v-model="selected"
      class="ocultar_check table-bordered"
      @current-items="$emit('currentItems', $event)"
    >
      <template v-slot:top>
        <div class="d-flex justify-end" v-show="!mostrar_busqueda && !acciones">
          <v-text-field
            v-show="mostrar_busqueda"
            dense
            flat
            :label="$utilidades.traduccion({ texto: label_busqueda })"
            prependInnerIcon="mdi-magnify"
            v-model="busqueda"
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <v-btn-toggle borderless v-if="acciones">
            <tooltip texto="PDF">
              <v-btn
                :loading="loadingButtons"
                color="#eef2f7"
                elevation="0"
                height="40px"
                tile
                @click="downloadPdf()"
              >
                <v-icon color="danger">mdi-file-pdf-box</v-icon>
              </v-btn>
            </tooltip>
            <tooltip texto="Excel">
              <v-btn
                :loading="loadingButtons"
                color="#eef2f7"
                elevation="0"
                height="40px"
                tile
                @click="downloadExcel()"
              >
                <v-icon color="success">mdi-file-excel-outline</v-icon>
              </v-btn>
            </tooltip>
            <tooltip texto="Csv">
              <v-btn
                :loading="loadingButtons"
                color="#eef2f7"
                elevation="0"
                height="40px"
                tile
                @click="downloadCSV()"
              >
                <v-icon color="violet">mdi-file-delimited-outline</v-icon>
              </v-btn>
            </tooltip>
            <tooltip :texto="$utilidades.traduccion({ texto: 'Copiar' })">
              <v-btn
                :loading="loadingButtons"
                color="#eef2f7"
                elevation="0"
                height="40px"
                tile
                @click="copyTable()"
              >
                <v-icon color="deafult">mdi-content-copy</v-icon>
              </v-btn>
            </tooltip>
            <tooltip :texto="$utilidades.traduccion({ texto: 'Imprimir' })">
              <v-btn
                :loading="loadingButtons"
                color="#eef2f7"
                elevation="0"
                height="40px"
                tile
                @click="printTable()"
              >
                <v-icon color="indigo">mdi-printer</v-icon>
              </v-btn>
            </tooltip>
          </v-btn-toggle>
        </div>
      </template>

      <template v-for="column in headers" v-slot:[`header.${column.value}`]>
        <slot v-if="column.text == ''" :name="`header-${column.value}`"></slot>
        <slot v-else :name="`header-${column.value}`">{{ column.text }}</slot>
      </template>

      <template
        v-for="column in headers"
        v-slot:[`item.${column.value}`]="{ item }"
      >
        <slot
          v-if="column.text == ''"
          :name="`item-${column.value}`"
          :item="item"
        ></slot>
        <slot
          v-else-if="column.fecha_hora"
          :name="`item-${column.value}`"
          :item="item"
        >
          {{ getFecha(item[column.value], true) }}
        </slot>
        <slot
          v-else-if="column.fecha"
          :name="`item-${column.value}`"
          :item="item"
        >
          {{ getFecha(item[column.value]) }}
        </slot>
        <slot
          v-else-if="column.moneda"
          :name="`item-${column.value}`"
          :item="item"
        >
          <!-- {{ $n(item[column.value], "currency") }} -->
          <!-- {{ $n(item[column.value], "currency") }} -->
          <span :class="item[column.value] < 0 ? 'text-danger' : ''">
            {{ getMoneda(item[column.value]) }}
          </span>
        </slot>
        <slot
          v-else-if="column.decimal"
          :name="`item-${column.value}`"
          :item="item"
        >
          {{ getDecimal(item[column.value]) }}
        </slot>
        <slot
          v-else-if="column.porcentaje"
          :name="`item-${column.value}`"
          :item="item"
        >
          {{ getPorcentage(item[column.value]) }}
        </slot>
        <slot v-else :name="`item-${column.value}`" :item="item">
          {{ item[column.value] }}</slot
        >
      </template>

      <template v-slot:[`item.#`]="{ index }">
        {{ index + 1 }}
      </template>

      <template v-slot:[`header.data-table-select`]="{ props, on }">
        <slot name="header-data-table-select" :props="props" :on="on">
          <v-simple-checkbox
            v-if="props.indeterminate"
            v-ripple
            v-bind="props"
            :value="props.indeterminate"
            v-on="on"
          ></v-simple-checkbox>
          <v-simple-checkbox
            v-if="!props.indeterminate"
            v-ripple
            v-bind="props"
            v-on="on"
          ></v-simple-checkbox>
        </slot>
      </template>

      <template
        v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
      >
        <slot
          name="item-data-table-select"
          :item="item"
          :isSelected="isSelected"
          :select="select"
        >
          <v-checkbox
            :input-value="isSelected"
            hide-details
            class="py-0 my-0"
            :style="item.isSelectable == false ? 'display:none' : ''"
            :disabled="item.isSelectable == null ? false : !item.isSelectable"
            @click="select(!isSelected)"
          />
        </slot>
      </template>
    </v-data-table>

    <v-data-table
      :headers="headersPrint"
      :items="itemsPrint"
      :search="busqueda"
      :id="id"
      :footer-props="{ 'items-per-page-options': [-1] }"
      class="ocultar_check table-bordered ocultar-tabla"
    >
      <template v-for="column in headers" v-slot:[`header.${column.value}`]>
        <slot v-if="column.text == ''" :name="`header-${column.value}`"></slot>
        <slot v-else :name="`header-${column.value}`">{{ column.text }}</slot>
      </template>

      <template
        v-for="column in headers"
        v-slot:[`item.${column.value}`]="{ item }"
      >
        <!-- <slot
          v-if="column.text == ''"
          :name="`item-${column.value}`"
          :item="item"
        ></slot> -->
        <!-- <slot :name="`item-${column.value}`" :item="item"> -->
        {{ item[column.value] }}
        <!-- </slot> -->
      </template>

      <template v-slot:[`item.#`]="{ index }">
        {{ index + 1 }}
      </template>

      <template v-slot:[`header.data-table-select`]="{}"> </template>

      <template v-slot:[`item.data-table-select`]="{}"> </template>
    </v-data-table>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { Utilidades } from "@/Util/Utilidades";

export default {
  name: "DataTable",
  props: {
    main: {
      deafult: true,
      type: Boolean,
    },
    mostrar_busqueda: {
      type: Boolean,
      default: true,
    },
    label_busqueda: {
      type: String,
      default: "Buscar",
    },
    custom_filter: {
      type: Object,
      default: null,
    },
    fixed_header: {
      type: Boolean,
      default: true,
    },
    show_select: {
      type: Boolean,
      default: false,
    },
    item_key: {
      type: String,
      default: "",
    },
    fixed_footer: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    items: [],
    headers: [],
    loading_text: {
      type: String,
      default: "Cargando datos ...",
    },
    density: {
      type: String,
      default: "default", //'default' | 'comfortable' | 'compact'
    },
    dense: {
      type: Boolean,
      default: true,
    },
    items_per_page: {
      type: Number,
      default: 25,
    },
    height: {
      type: String,
      default: "",
    },
    disable_pagination: {
      type: Boolean,
      default: false,
    },
    hide_default_footer: {
      type: Boolean,
      default: false,
    },
    acciones: {
      type: Boolean,
      default: true,
    },
    locale: {
      type: String,
      default: "es",
    },
    value: Array,
  },
  components: {
    DataTableHijo: () => import("@/components/DataTable.vue"),
  },
  data: function () {
    return {
      busqueda: "",
      id: "table_" + Math.random().toString(16).slice(2),
      selected: [],
      headersPrint: [],
      itemsPrint: [],
      loadingButtons: false,
    };
  },
  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.selected = val;
      },
    },
  },
  methods: {
    async getTable() {
      this.loadingButtons = true;
      this.headersPrint = Utilidades.clonarObjeto(
        this.headers.filter((x) => x.width != "0%")
      );
      this.itemsPrint = Utilidades.clonarObjeto(this.items);

      await Utilidades.sleep(500);

      this.loadingButtons = false;
      return document.getElementById(this.id).children[0].children[0];
    },
    async downloadPdf() {
      const doc = new jsPDF({ format: "letter", orientation: "landscape" });
      //theme = striped'|'grid'|'plain'
      autoTable(doc, {
        html: await this.getTable(),
        theme: "striped",
        didParseCell: function (cell) {
          let _classTd = cell?.cell?.raw?.className;
          let _classCell = cell?.cell?.raw?.children[0]?.className;

          if (_classCell?.toString()?.includes("text-danger")) {
            cell.cell.styles.textColor = [250, 103, 103];
          }

          if (_classTd?.toString()?.includes("text-right")) {
            cell.cell.styles.halign = "right";
          }
        },
      });
      doc.save(this.$route.meta.title + ".pdf");
    },
    async downloadExcel() {
      var wb = XLSX.utils.table_to_book(await this.getTable());
      XLSX.writeFile(wb, this.$route.meta.title + ".xlsx");
    },
    async downloadCSV() {
      var wb = XLSX.utils.table_to_book(await this.getTable());

      XLSX.writeFile(wb, this.$route.meta.title + ".csv", { bookType: "csv" });
    },
    async copyTable() {
      var table = await this.getTable();

      if (navigator.clipboard) {
        var text = table.innerText.trim();
        navigator.clipboard.writeText(text).catch(function () {});

        Utilidades.Message({ message: "Copiado!" });
      }
    },
    async printTable() {
      var table = await this.getTable();
      var divToPrint = table;

      var element = table.getElementsByTagName("button"),
        index;

      for (index = element.length - 1; index >= 0; index--) {
        element[index].className = element[index].className + " no-print";
      }

      let print = `<html>
        <head>
          <style>
            th {
              background-color: #474d56;
              border-color: #58606b;              
              color: #98a6ad;
              text-transform: uppercase;
              font-size: 0.75rem !important;
              ont-weight: 400;
              border: 1px solid #eef2f;
            }

            tr {
              height: 40px !important
            }

            td {              
              height: 35px !important;
            }   
            
            @media print
            {    
              .no-print, .no-print *
              {
                display: none !important;
              }
            }                   
          </style>
        </head>
        <body>
        ${divToPrint.outerHTML}
        </body>
      </html>`;

      var newWin = window.open("");
      newWin.document.write(print);
      newWin.print();
      newWin.close();
    },
    getFecha(val, time = false) {
      if (Utilidades.isNullOrUndefinedOrEmpty(val)) {
        return "";
      } else {
        let fecha = new Date(val);

        //Fecha no valida
        if (isNaN(fecha.getDate())) {
          return "";
        } else {
          return this.$d(fecha, time ? "time" : "short").replace(",", "");
        }
      }
    },
    getMoneda(val) {
      if (isNaN(Number.parseFloat(val))) {
        return "";
      } else {
        return this.$n(val, "currency");
      }
    },
    getPorcentage(val) {
      if (isNaN(Number.parseFloat(val))) {
        return "";
      } else {
        return this.$n(val / 100, "percent");
      }
    },
    getDecimal(val) {
      if (isNaN(Number.parseFloat(val))) {
        return "";
      } else {
        return this.$n(val, "decimal");
      }
    },
  },
};
</script>
<style>
.ocultar-tabla {
  display: none;
}
</style>
